export default __webpack_public_path__ + "static/media/shift-right.b542aff8.svg";